// ---- Device type
export const DeviceType = {
    MOBILE: "mobile",
    TABLET: "tablet",
    DESKTOP: "desktop"
}